import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faEye } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-hot-toast';

const claimStatusStyles = {
  'NULL': 'bg-gray-100 text-gray-800',
  'For Processing': 'bg-blue-100 text-blue-800',
  'Processed': 'bg-green-100 text-green-800',
  'Extracted': 'bg-yellow-100 text-yellow-800',
  'Incomplete': 'bg-red-100 text-red-800',
  'Paid': 'bg-purple-100 text-purple-800',
};

const ClaimDetailsModal = ({ isOpen, onClose, claim, phpFormatter }) => {
  if (!isOpen || !claim) return null;

  const loaDocumentUrl = claim.loa_document
    ? `https://allaccess.net.ph/upload_doc/loa/${claim.loa_document}`
    : null;

  const handleOpenLoaDocument = () => {
    if (loaDocumentUrl) {
      window.open(loaDocumentUrl, '_blank');
    } else {
      toast.error('No LOA document available.', { duration: 4000 });
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[80vh] overflow-y-auto transform transition-all duration-300 scale-100">
        {/* Modal Header */}
        <div className="p-6 border-b border-gray-100 flex justify-between items-center">
          <h2 className="text-xl font-semibold text-gray-800">Claim Details</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
            aria-label="Close modal"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        {/* Modal Body */}
        <div className="p-6">
          <div className="grid grid-cols-1 gap-4">
            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Loa No.:</span>
              <span className="text-gray-900">{claim.loa_no}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Transaction No.:</span>
              <span className="text-gray-900">{claim.transaction_no}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Amount:</span>
              <span className="text-gray-900">{phpFormatter.format(claim.amount)}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Patient Name:</span>
              <span className="text-gray-900">{claim.patient_name}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Coverage:</span>
              <span className="text-gray-900">{claim.coverage}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Date:</span>
              <span className="text-gray-900">{claim.date}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Claim Status:</span>
              <span
                className={`px-2 py-1 rounded-full text-xs ${
                  claimStatusStyles[claim.claim_status] || claimStatusStyles['NULL']
                }`}
              >
                {claim.claim_status || 'NULL'}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Stale?:</span>
              <span className="text-gray-900">{claim.stale ? 'Yes' : 'No'}</span>
            </div>
            {loaDocumentUrl && (
              <div className="mt-4">
                <button
                  onClick={handleOpenLoaDocument}
                  className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 flex items-center gap-2"
                >
                  <FontAwesomeIcon icon={faEye} />
                  View LOA Document
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Modal Footer */}
        <div className="p-6 border-t border-gray-100 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClaimDetailsModal;